<template>
  <div class="institution-card-container">
    <!-- Header moderno -->
    <div class="institution-header">
      <div class="header-content">
        <h4 class="institution-title">
          <b-icon-building class="title-icon"></b-icon-building>
          {{
            institution
              ? institution.name
              : $t("toolbar.institutionCard.institution")
          }}
        </h4>
        <p class="institution-subtitle">
          {{ $t("toolbar.institutionCard.configurationAndInstitutionalData") }}
        </p>
      </div>
    </div>
    <b-card v-if="institution" class="institution-card" no-body>
      <!-- Sección de imagen institucional -->
      <div class="image-section">
        <div class="image-container">
          <div class="image-wrapper">
            <template v-if="institution && institution.image">
              <ImageEditor
                :key="user_image_key"
                :display_options="false"
                :portrait_size="true"
                :image_id="institution.image"
                :allows_crud="allows_crud"
                @deleted="slotImageDeleted"
                class="institution-image"
              ></ImageEditor>
            </template>
            <template v-else>
              <div class="default-image">
                <b-icon-building class="default-icon"></b-icon-building>
              </div>
            </template>
          </div>
          <ButtonMedium
            :tooltip_text="''"
            :text_button="
              institution.image
                ? $t('toolbar.institutionCard.changeLogo')
                : $t('toolbar.institutionCard.uploadLogo')
            "
            :click_button="() => $bvModal.show('modal-select-image')"
            :icon="''"
            :variant="'primary'"
            :custom_class="``"
            :disabled_button="!allows_crud"
          >
          </ButtonMedium>
        </div>
      </div>
      <!-- Sección de configuración -->
      <div class="config-section">
        <div class="config-content">
          <!-- Sección de Calificaciones -->
          <div class="config-group">
            <div class="group-header">
              <h5 class="group-title">
                <b-icon-award class="group-icon"></b-icon-award>
                {{ $t("toolbar.institutionCard.gradingSystem") }}
              </h5>
              <div class="group-subtitle">
                {{
                  $t(
                    "toolbar.institutionCard.gradesAndEvaluationsConfiguration"
                  )
                }}
              </div>
            </div>
            <div class="fields-grid">
              <b-form-group class="modern-form-group">
                <label class="modern-label">
                  <span class="label-text">{{
                    $t("toolbar.institutionCard.minGrade")
                  }}</span>
                  <InfoTooltip
                    v-if="institution_has_grades"
                    :tooltip_text="
                      $t('toolbar.institutionCard.gradeLockedMessage', {
                        gradeType: $t('toolbar.institutionCard.minGrade'),
                      })
                    "
                    class="label-tooltip"
                  ></InfoTooltip>
                </label>
                <b-form-input
                  type="number"
                  min="0"
                  v-model="$v.institution.min_grade.$model"
                  :disabled="!allows_crud || institution_has_grades"
                  :state="validateState('min_grade')"
                  class="modern-input"
                  placeholder="1"
                ></b-form-input>
                <b-form-invalid-feedback class="modern-feedback">
                  <div v-if="parseFloat(institution.min_grade) < 0">
                    {{
                      $t(
                        "toolbar.institutionCard.mustBeGreaterThanOrEqualToZero"
                      )
                    }}
                  </div>
                  <div
                    v-if="
                      parseFloat(institution.min_grade) >=
                      parseFloat(institution.appr_grade)
                    "
                  >
                    {{
                      $t(
                        "toolbar.institutionCard.cannotBeGreaterThanOrEqualToPassingGrade"
                      )
                    }}
                  </div>
                </b-form-invalid-feedback>
              </b-form-group>

              <b-form-group class="modern-form-group">
                <label class="modern-label">
                  <span class="label-text">{{
                    $t("toolbar.institutionCard.passingGrade")
                  }}</span>
                  <InfoTooltip
                    v-if="institution_has_grades"
                    :tooltip_text="
                      $t('toolbar.institutionCard.gradeLockedMessage', {
                        gradeType: $t('toolbar.institutionCard.passingGrade'),
                      })
                    "
                    class="label-tooltip"
                  ></InfoTooltip>
                </label>
                <b-form-input
                  type="number"
                  min="0"
                  v-model="$v.institution.appr_grade.$model"
                  :disabled="!allows_crud || institution_has_grades"
                  :state="validateState('appr_grade')"
                  class="modern-input"
                  placeholder="7"
                ></b-form-input>
                <b-form-invalid-feedback class="modern-feedback">
                  <div v-if="parseFloat(institution.appr_grade) < 0">
                    {{
                      $t(
                        "toolbar.institutionCard.mustBeGreaterThanOrEqualToZero"
                      )
                    }}
                  </div>
                  <div
                    v-if="
                      parseFloat(institution.max_grade) <
                      parseFloat(institution.appr_grade)
                    "
                  >
                    {{
                      $t("toolbar.institutionCard.cannotBeGreaterThanMaxGrade")
                    }}
                  </div>
                </b-form-invalid-feedback>
              </b-form-group>
              <b-form-group class="modern-form-group">
                <label class="modern-label">
                  <span class="label-text">{{
                    $t("toolbar.institutionCard.maxGrade")
                  }}</span>
                  <InfoTooltip
                    v-if="institution_has_grades"
                    :tooltip_text="
                      $t('toolbar.institutionCard.gradeLockedMessage', {
                        gradeType: $t('toolbar.institutionCard.maxGrade'),
                      })
                    "
                    class="label-tooltip"
                  ></InfoTooltip>
                </label>
                <b-form-input
                  type="number"
                  min="0"
                  v-model="$v.institution.max_grade.$model"
                  :disabled="!allows_crud || institution_has_grades"
                  :state="validateState('max_grade')"
                  class="modern-input"
                  placeholder="7"
                ></b-form-input>
                <b-form-invalid-feedback class="modern-feedback">
                  <div v-if="parseFloat(institution.max_grade) < 0">
                    {{
                      $t(
                        "toolbar.institutionCard.mustBeGreaterThanOrEqualToZero"
                      )
                    }}
                  </div>
                  <div
                    v-if="
                      parseFloat(institution.max_grade) <
                      parseFloat(institution.appr_grade)
                    "
                  >
                    {{
                      $t("toolbar.institutionCard.cannotBeLessThanPassingGrade")
                    }}
                  </div>
                  <div
                    v-if="
                      parseFloat(institution.max_grade) <
                      parseFloat(institution.min_grade)
                    "
                  >
                    {{ $t("toolbar.institutionCard.cannotBeLessThanMinGrade") }}
                  </div>
                </b-form-invalid-feedback>
              </b-form-group>
              <b-form-group class="modern-form-group">
                <label class="modern-label">
                  <span class="label-text">{{
                    $t("toolbar.institutionCard.exigencePercentage")
                  }}</span>
                  <InfoTooltip
                    :tooltip_text="
                      $t('toolbar.institutionCard.exigencePercentageTooltip')
                    "
                    class="label-tooltip"
                  ></InfoTooltip>
                </label>
                <b-form-input
                  type="number"
                  min="0"
                  max="100"
                  v-model="$v.institution.exigence_percentage.$model"
                  :disabled="!allows_crud || institution_has_grades"
                  :state="validateState('exigence_percentage')"
                  class="modern-input"
                  placeholder="60"
                ></b-form-input>
                <b-form-invalid-feedback class="modern-feedback">
                  {{
                    $t("toolbar.institutionCard.mustBeBetweenZeroAndHundred")
                  }}
                </b-form-invalid-feedback>
              </b-form-group>
            </div>
          </div>

          <!-- Sección Sistema Académico -->
          <div class="config-group">
            <div class="group-header">
              <h5 class="group-title">
                <b-icon-clock class="group-icon"></b-icon-clock>
                {{ $t("toolbar.institutionCard.academicSystem") }}
              </h5>
              <div class="group-subtitle">
                {{
                  $t("toolbar.institutionCard.creditsAndSchedulesConfiguration")
                }}
              </div>
            </div>
            <div class="fields-grid">
              <!-- <template>
            <b-form-group
              label-cols="0"
              label-cols-sm="7"
              label-for="input-first_grade_cut"
              class="my-2 mx-0"
            >
              <template #label>
                <div class="block-title-container">
                  <div>Corte de Nota 1:</div>
                  <div class="ml-2">
                    <InfoTooltip
                      :tooltip_text="`Corte de nota 1`"
                    ></InfoTooltip>
                  </div>
                </div>
              </template>
              <b-form-input
                id="input-first_grade_cut"
                type="number"
                min="0"
                v-model="$v.institution.first_grade_cut.$model"
                :disabled="!allows_crud"
                :state="validateState('first_grade_cut')"
                aria-describedby="input-first_grade_cut-feedback"
                size="sm"
              ></b-form-input>
              <b-form-invalid-feedback id="input-first_grade_cut-feedback"
                ><div v-if="parseFloat(institution.first_grade_cut) < 0">
                  Este campo debe ser mayor o igual a cero.
                </div>
                <div
                  v-if="
                    institution.first_grade_cut < institution.second_grade_cut
                  "
                >
                  La Corte de Nota 1 no puede ser menor que el Corte de Nota 2.
                </div></b-form-invalid-feedback
              >
            </b-form-group>
          </template> -->
              <!-- <template>
            <b-form-group
              label-cols="0"
              label-cols-sm="7"
              label-for="input-second_grade_cut"
              class="my-2 mx-0"
            >
              <template #label>
                <div class="block-title-container">
                  <div>Corte de Nota 2:</div>
                  <div class="ml-2">
                    <InfoTooltip
                      :tooltip_text="`Corte de nota 2`"
                    ></InfoTooltip>
                  </div>
                </div>
              </template>
              <b-form-input
                id="input-second_grade_cut"
                type="number"
                min="0"
                v-model="$v.institution.second_grade_cut.$model"
                :disabled="!allows_crud"
                :state="validateState('second_grade_cut')"
                aria-describedby="input-second_grade_cut-feedback"
                size="sm"
              ></b-form-input>
              <b-form-invalid-feedback id="input-second_grade_cut-feedback"
                ><div v-if="parseFloat(institution.second_grade_cut) < 0">
                  Este campo debe ser mayor o igual a cero.
                </div>
                <div
                  v-if="
                    institution.first_grade_cut < institution.second_grade_cut
                  "
                >
                  La Corte de Nota 2 no puede ser mayor que el Corte de Nota 1.
                </div></b-form-invalid-feedback
              >
            </b-form-group>
          </template> -->

              <!-- Segunda parte -->
              <!-- <template>
            <b-form-group
              label-cols="0"
              label-cols-sm="7"
              label-for="input-first_achievement_cut"
              class="my-2 mx-0"
            >
              <template #label>
                <div class="block-title-container">
                  <div>Corte de Logro 1:</div>
                  <div class="ml-2">
                    <InfoTooltip
                      :tooltip_text="`Corte de Logro 1`"
                    ></InfoTooltip>
                  </div>
                </div>
              </template>
              <b-form-input
                id="input-first_achievement_cut"
                type="number"
                min="0"
                v-model="$v.institution.first_achievement_cut.$model"
                :disabled="!allows_crud"
                :state="validateState('first_achievement_cut')"
                aria-describedby="input-first_achievement_cut-feedback"
                size="sm"
              ></b-form-input>
              <b-form-invalid-feedback
                id="input-first_achievement_cut-feedback"
              >
                <div
                  v-if="
                    parseFloat(institution.first_achievement_cut) < 0 ||
                    parseFloat(institution.first_achievement_cut) > 100
                  "
                >
                  Este campo debe ser mayor o igual a cero y menor o igual a
                  100.
                </div>
                <div
                  v-if="
                    institution.first_achievement_cut <
                    institution.second_achievement_cut
                  "
                >
                  El Corte de Logro 1 no puede ser menor que el Corte de Logro
                  2.
                </div>
              </b-form-invalid-feedback>
            </b-form-group>
          </template> -->
              <!-- <template>
            <b-form-group
              label-cols="0"
              label-cols-sm="7"
              label-for="input-second_achievement_cut"
              class="my-2 mx-0"
            >
              <template #label>
                <div class="block-title-container">
                  <div>Corte de Logro 2:</div>
                  <div class="ml-2">
                    <InfoTooltip
                      :tooltip_text="`Corte de Logro 1`"
                    ></InfoTooltip>
                  </div>
                </div>
              </template>
              <b-form-input
                id="input-second_achievement_cut"
                type="number"
                min="0"
                v-model="$v.institution.second_achievement_cut.$model"
                :disabled="!allows_crud"
                :state="validateState('second_achievement_cut')"
                aria-describedby="input-second_achievement_cut-feedback"
                size="sm"
              ></b-form-input>
              <b-form-invalid-feedback
                id="input-second_achievement_cut-feedback"
              >
                <div
                  v-if="
                    parseFloat(institution.second_achievement_cut) < 0 ||
                    parseFloat(institution.second_achievement_cut) > 100
                  "
                >
                  Este campo debe ser mayor o igual a cero y menor o igual a
                  100.
                </div>
                <div
                  v-if="
                    institution.first_achievement_cut <
                    institution.second_achievement_cut
                  "
                >
                  El Corte de Logro 2 no puede ser mayor que el Corte de Logro
                  1.
                </div></b-form-invalid-feedback
              >
            </b-form-group>
          </template> -->
              <b-form-group class="modern-form-group">
                <label class="modern-label">
                  <span class="label-text">{{
                    $t("toolbar.institutionCard.hoursPerSCTCredit")
                  }}</span>
                  <InfoTooltip
                    :tooltip_text="
                      $t('toolbar.institutionCard.hoursPerCreditTooltip')
                    "
                    class="label-tooltip"
                  ></InfoTooltip>
                </label>
                <b-form-input
                  type="number"
                  min="0"
                  v-model="$v.institution.hours_per_credit.$model"
                  :disabled="!allows_crud"
                  :state="validateState('hours_per_credit')"
                  class="modern-input"
                  placeholder="30"
                ></b-form-input>
                <b-form-invalid-feedback class="modern-feedback">
                  {{
                    $t("toolbar.institutionCard.mustBeGreaterThanOrEqualToZero")
                  }}
                </b-form-invalid-feedback>
              </b-form-group>
              <!-- <template>
            <b-form-group
              label-cols="0"
              label-cols-sm="7"
              label-for="input-max_semester_amount"
              class="my-2 mx-0"
            >
              <template #label>
                <div class="block-title-container">
                  <div>
                    Niveles del
                    {{
                      $getVisibleNames(
                        "mesh.egressprofile",
                        false,
                        "Perfil de Egreso"
                      )
                    }}
                    (valor por defecto):
                  </div>
                  <div class="ml-2">
                    <InfoTooltip
                      :tooltip_text="` Cantidad de niveles sugeridos durante la creación de un ${$getVisibleNames(
                        'mesh.egressprofile',
                        false,
                        'Perfil de Egreso'
                      )}. Influye en la estructura del Plan de Estudio y la Malla Curricular (Siempre y cuando no existan ''${$getVisibleNames(
                        'mesh.cycle',
                        true,
                        'Ciclos Formativos'
                      )}'' asociados).`"
                    ></InfoTooltip>
                  </div>
                </div>
              </template>
              <b-form-input
                id="input-max_semester_amount"
                type="number"
                min="0"
                v-model="$v.institution.max_semester_amount.$model"
                :disabled="!allows_crud"
                :state="validateState('max_semester_amount')"
                aria-describedby="input-max_semester_amount-feedback"
                size="sm"
              ></b-form-input>
              <b-form-invalid-feedback id="input-max_semester_amount-feedback"
                >Este campo debe ser mayor o igual a 1.</b-form-invalid-feedback
              >
            </b-form-group>
          </template> -->
              <b-form-group class="modern-form-group">
                <label class="modern-label">
                  <span class="label-text">{{
                    $t("toolbar.institutionCard.minutesPerPedagogicalHour")
                  }}</span>
                  <InfoTooltip
                    :tooltip_text="
                      $t('toolbar.institutionCard.minutesPerHourTooltip')
                    "
                    class="label-tooltip"
                  ></InfoTooltip>
                </label>
                <b-form-input
                  type="number"
                  min="1"
                  v-model="$v.institution.module_minutes.$model"
                  :disabled="!allows_crud"
                  :state="validateState('module_minutes')"
                  class="modern-input"
                  placeholder="45"
                ></b-form-input>
                <b-form-invalid-feedback class="modern-feedback">
                  {{
                    $t("toolbar.institutionCard.mustBeGreaterThanOrEqualToOne")
                  }}
                </b-form-invalid-feedback>
              </b-form-group>
            </div>
          </div>

          <!-- Sección de guardado -->
          <div class="save-section" v-if="allows_crud">
            <ButtonMedium
              v-if="allows_crud"
              :tooltip_text="''"
              :text_button="$t('toolbar.institutionCard.saveChanges')"
              :click_button="save"
              :icon="''"
              :variant="'primary'"
              :custom_class="``"
              :disabled_button="$v.institution.$anyError"
            >
            </ButtonMedium>
          </div>
          <!-- <template>
            <b-form-group
              label-cols="0"
              label-cols-sm="7"
              label-for="global_reach"
              class="label m-0 align-middle mb-2"
            >
              <template #label>
                <div class="block-title-container">
                  <div>Visión Completa por Defecto.</div>
                  <div class="ml-2">
                    <InfoTooltip
                      :tooltip_text="`Determina si al momento de crear un usuario, este tiene acceso a todos los recursos disponibles, o se deben otorgar manualmente`"
                    ></InfoTooltip>
                  </div>
                </div>
              </template> -->
          <!-- <template #label> -->
          <!-- <div class="weighing-label">
                  <div class="label-content">
                    Todos los Permisos por Defecto. -->
          <!-- <span>
                      <InfoTooltip
                  class="info-icon"
                  :tooltip_text="`Permite la asignación de un ${$getVisibleNames(
                    'teaching.basera',
                    false,
                    'RA Base'
                  )} ya relacionado a otra ${$getVisibleNames(
                    'mesh.egressprofilematter',
                    false,
                    'Asignatura'
                  )}.
                  `"
                >
                </InfoTooltip>
                    </span> -->
          <!-- </div>
                </div>
              </template> -->
          <!-- <div id="global_reach" class="align-middle">
                <div class="d-flex">
                  <div class="toggle-types noprint">
                    <span
                      :class="{
                        'font-weight-bold': institution.global_reach,
                      }"
                      >Si</span
                    >
                    <b-button
                      class="check-type"
                      :disabled="!allows_crud"
                      @click="
                        () => {
                          institution.global_reach = !institution.global_reach;
                        }
                      "
                      variant="primary"
                    >
                      <b-icon
                        icon="circle-fill"
                        class="icon-check"
                        :class="{
                          'icon-check-active': !institution.global_reach,
                        }"
                        scale="0.7"
                      ></b-icon>
                    </b-button>
                    <span
                      :class="{
                        'font-weight-bold': !institution.global_reach,
                      }"
                      >No</span
                    >
                  </div>
                </div>
              </div>
            </b-form-group>
          </template> -->
        </div>
      </div>
    </b-card>
    <b-modal
      id="modal-select-image"
      :title="$t('toolbar.institutionCard.selectImage')"
      hide-footer
      size="md"
    >
      <ImageSelector @created="slotImageCreated"></ImageSelector>
    </b-modal>
  </div>
</template>

<script>
import * as names from "@/store/names";
import { mapGetters } from "vuex";
import { validationMixin } from "vuelidate";
import {
  toast,
} from "@/utils/utils";

// minLength,
import {
  required,
  minValue,
  maxValue,
  // numeric,
} from "vuelidate/lib/validators";
export default {
  name: "InstitutionCard",
  mixins: [validationMixin],
  components: {
    ImageEditor: () => import("@/components/reusable/ImageEditor"),
    ImageSelector: () => import("@/components/reusable/ImageSelector"),
    InfoTooltip: () => import("@/components/reusable/InfoTooltip"),
    ButtonMedium: () =>
      import("@/components/reusable/Buttons/Medium/ButtonMedium"),
  },
  props: {
    allows_crud: {
      type: Boolean,
    },
  },
  data() {
    return {
      user_image_key: 0,
      institution: null,
      institution_has_grades: false,
    };
  },
  validations: {
    institution: {
      min_grade: {
        required,
        // numeric,
        minValue: minValue(0),
        is_valid() {
          if (
            parseFloat(this.institution.min_grade) <=
            parseFloat(this.institution.appr_grade)
          )
            return true;
          else return false;
        },
      },
      appr_grade: {
        required,
        // numeric,
        is_valid() {
          if (
            parseFloat(this.institution.appr_grade) <
            parseFloat(this.institution.max_grade)
          )
            return true;
          else return false;
        },
        minValue: minValue(0),
      },
      max_grade: {
        required,
        // numeric,
        is_valid() {
          if (
            parseFloat(this.institution.max_grade) >
              parseFloat(this.institution.appr_grade) &&
            parseFloat(this.institution.max_grade) >
              parseFloat(this.institution.min_grade)
          )
            return true;
          else return false;
        },
        minValue: minValue(0),
      },
      first_grade_cut: {
        required,
        // numeric,
        is_valid() {
          if (
            parseFloat(this.institution.first_grade_cut) <=
            parseFloat(this.institution.second_grade_cut)
          )
            return true;
          else return false;
        },
        minValue: minValue(0),
      },
      second_grade_cut: {
        required,
        // numeric,
        is_valid() {
          if (
            parseFloat(this.institution.first_grade_cut) <=
            parseFloat(this.institution.second_grade_cut)
          )
            return true;
          else return false;
        },
        minValue: minValue(0),
      },
      exigence_percentage: {
        required,
        // numeric,
        minValue: minValue(0),
        maxValue: maxValue(100),
      },
      first_achievement_cut: {
        required,
        // numeric,
        is_valid() {
          if (
            parseFloat(this.institution.first_achievement_cut) <=
            parseFloat(this.institution.second_achievement_cut)
          )
            return true;
          else return false;
        },
        minValue: minValue(0),
        maxValue: maxValue(100),
      },
      second_achievement_cut: {
        required,
        // numeric,
        is_valid() {
          if (
            parseFloat(this.institution.first_achievement_cut) <=
            parseFloat(this.institution.second_achievement_cut)
          )
            return true;
          else return false;
        },
        minValue: minValue(0),
        maxValue: maxValue(100),
      },
      hours_per_credit: {
        required,
        // numeric,
        minValue: minValue(0),
      },
      max_semester_amount: {
        required,
        // numeric,
        minValue: minValue(1),
      },
      module_minutes: {
        required,
        // numeric,
        minValue: minValue(1),
      },
    },
  },
  computed: {
    ...mapGetters({
      Institution: "getInstitution",
    }),
  },
  methods: {
    
    validateState(name) {
      const { $dirty, $error } = this.$v.institution[name];
      return $dirty ? !$error : null;
    },
    save() {
      this.$v.institution.$touch();
      if (this.$v.institution.$anyError) {
        return;
      }
      const payload = {
        id: this.institution.id,
        item: {
          min_grade: this.institution.min_grade,
          appr_grade: this.institution.appr_grade,
          max_grade: this.institution.max_grade,
          first_grade_cut: this.institution.first_grade_cut,
          second_grade_cut: this.institution.second_grade_cut,
          exigence_percentage: this.institution.exigence_percentage,
          first_achievement_cut: this.institution.first_achievement_cut,
          second_achievement_cut: this.institution.second_achievement_cut,
          hours_per_credit: this.institution.hours_per_credit,
          global_reach: this.institution.global_reach,
          max_semester_amount: this.institution.max_semester_amount,
          module_minutes: this.institution.module_minutes,
        },
      };
      this.$restful
        .Patch(`/mesh/institution/${payload.id}/`, payload.item)
        .then((response) => {
          this.institution = response;
          this.$store.commit("setUserInstitution", response);
          toast(this.$t("toolbar.institutionCard.institutionUpdated"));
        });
    },
    slotImageDeleted() {
      const payload = {
        id: this.institution.id,
        item: { image: null },
      };
      this.$restful
        .Patch(`/mesh/institution/${payload.id}/`, payload.item)
        .then((response) => {
          this.institution = response;
          this.$store.commit("setUserInstitution", response);
          this.$store.commit("setInstitutionLogo", null);
          toast(this.$t("toolbar.institutionCard.institutionLogoDeleted"));
        });
    },
    slotImageCreated(image) {
      if (image) {
        const payload = {
          id: this.institution.id,
          item: { image: image.id },
        };
        this.$restful
          .Patch(`/mesh/institution/${payload.id}/`, payload.item)
          .then((response) => {
            this.institution = response;
            this.$store.commit("setUserInstitution", response);
            if (response.image) {
              this.$store
                .dispatch(names.FETCH_IMAGE, response.image)
                .then((image) => {
                  this.$store.commit("setInstitutionLogo", image.image);
                  toast(
                    this.$t("toolbar.institutionCard.institutionLogoUpdated")
                  );
                });
            }
          });
      }
      this.$bvModal.hide("modal-select-image");
    },
  },
  mounted() {
    this.institution = { ...this.Institution };
    this.$restful.Get(`/teaching/institution_has_grades/`).then((response) => {
      this.institution_has_grades = response;
    });
  },
  created() {},
};
</script>

<style scoped>
/* Container principal */
.institution-card-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 1.5rem;
}

/* Header moderno */
.institution-header {
  background: linear-gradient(
    135deg,
    var(--kl-color-accent-medium) 0%,
    var(--kl-color-primary) 100%
  );
  border-radius: 12px 12px 0 0;
  padding: 2rem;
  color: white;
  margin-bottom: 0;
}

.header-content {
  text-align: center;
}

.institution-title {
  font-size: 1.8rem;
  font-weight: 600;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
}

.title-icon {
  font-size: 2rem;
}

.institution-subtitle {
  margin: 0.5rem 0 0 0;
  opacity: 0.9;
  font-size: 1rem;
}

/* Card principal */
.institution-card {
  border-radius: 0 0 12px 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.09);
  border: none;
  overflow: hidden;
}

/* Sección de imagen */
.image-section {
  background: #f8f9fa;
  padding: 2rem;
  border-bottom: 1px solid #e9ecef;
}

.image-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.image-wrapper {
  width: 350px;
  height: 150px;
  border-radius: 16px;
  padding: 1em;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
}

.default-image {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #e9ecef 0%, #f8f9fa 100%);
}

.default-icon {
  font-size: 3rem;
  color: #6c757d;
}

.institution-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  align-content: center;
}

.image-button {
  border-radius: 8px;
  padding: 0.5rem 1.5rem;
  font-weight: 500;
  transition: all 0.3s ease;
}

.image-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.3);
}

/* Sección de configuración */
.config-section {
  padding: 2rem;
}

.config-content {
  display: flex;
  flex-direction: column;
  gap: 2.5rem;
}

/* Grupos de configuración */
.config-group {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 1.5rem;
  border-left: 4px solid var(--primary-color, #007bff);
}

.group-header {
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #e9ecef;
}

.group-title {
  font-size: 1.2rem;
  font-weight: 600;
  margin: 0 0 0.5rem 0;
  color: #495057;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.group-icon {
  color: var(--primary-color, #007bff);
}

.group-subtitle {
  color: #6c757d;
  font-size: 0.9rem;
  margin: 0;
}

/* Grid de campos */
.fields-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1.5rem;
}

/* Form groups modernos */
.modern-form-group {
  margin: 0;
}

.modern-label {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 600;
  color: #495057;
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
}

.label-text {
  flex: 1;
}

.label-tooltip {
  margin-left: 0.5rem;
}

.modern-input {
  border-radius: 8px;
  border: 2px solid #e9ecef;
  padding: 0.75rem 1rem;
  font-size: 0.95rem;
  transition: all 0.3s ease;
  background: white;
}

.modern-input:focus {
  border-color: var(--primary-color, #007bff);
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  transform: translateY(-1px);
}

.modern-input:disabled {
  background-color: #f8f9fa;
  opacity: 0.8;
}

.modern-feedback {
  font-size: 0.85rem;
  margin-top: 0.25rem;
}

/* Sección de guardado */
.save-section {
  padding: 2rem;
  border-top: 1px solid #e9ecef;
  background: #f8f9fa;
  text-align: center;
}

.save-button {
  padding: 0.75rem 2rem;
  border-radius: 10px;
  font-weight: 600;
  font-size: 1rem;
  background: linear-gradient(
    135deg,
    var(--primary-color, #007bff) 0%,
    var(--primary-hover-color, #0056b3) 100%
  );
  border: none;
  box-shadow: 0 4px 15px rgba(0, 123, 255, 0.3);
  transition: all 0.3s ease;
}

.save-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 123, 255, 0.4);
}

/* Responsivo */
@media (max-width: 768px) {
  .institution-card-container {
    padding: 1rem;
  }

  .institution-header {
    padding: 1.5rem 1rem;
  }

  .institution-title {
    font-size: 1.5rem;
  }

  .fields-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .config-section {
    padding: 1.5rem;
  }

  .config-group {
    padding: 1rem;
  }
}

@media (max-width: 480px) {
  .institution-header {
    padding: 1rem;
  }

  .institution-title {
    font-size: 1.3rem;
    flex-direction: column;
    gap: 0.5rem;
  }

  .image-section {
    padding: 1.5rem 1rem;
  }

  .config-section {
    padding: 1rem;
  }

  .image-wrapper {
    width: 100px;
    height: 100px;
  }
}

/* Compatibilidad con estilos existentes */
.block-title-container {
  display: flex;
  justify-content: space-between;
}

.info-icon {
  position: relative;
  vertical-align: top;
  height: 12px;
  width: 12px;
}
</style>